import axios from "@/libs/http";

/**
 * 获取我的资料
 */
export const getKf = () => {
    return axios.request({
        url: '/s/k/kf/get',
        params: {
        },
        method: 'get'
    })
}

/**
 * 修改状态
 */
export const updateKfStatus = (status) => {
    return axios.request({
        url: '/s/k/kf/updateStatus',
        params: {
            status
        },
        method: 'post'
    })
}
